import { Provider } from "@fluentui/react-northstar";
import { registerOnThemeChangeHandler } from "libs/teams/helper";
import { ReactNode, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { rnsThemeState } from "states/fluent-ui";
import { msTeamsThemeState, teamsAppThemeList } from "states/ms-teams";

type Props = {
  children: ReactNode;
};

/**
 * @description
 * 1. `@fluentui/react-northstar` 를 사용할 수 있도록 Provider를 제공합니다.
 * 1. 기본적으로 제공하는 theme값 이외 추가되는 style을 공유하기 위해서 사용됩니다.
 * 1. 또한, 여러 UI Framework를 사용하는 경우 Provider 충돌이 잘 이뤄남으로 앱 전체적으로 theme Provider를 적용하는 것은 위험합니다. 이런 경우 유용하게 사용할 수 있습니다.
 */
export default function FluentUINorthstarProvider({ children }: Props) {
  const setMsTeamsTheme = useSetRecoilState(msTeamsThemeState);
  const rnsTheme = useRecoilValue(rnsThemeState);

  // TODO: 이것도 최적화할 수 없을까?
  useEffect(() => {
    registerOnThemeChangeHandler((theme: string) =>
      setMsTeamsTheme(theme as teamsAppThemeList)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider
      theme={rnsTheme}
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      {children}
    </Provider>
  );
}
